import { type FC } from 'react'

import SvgIcon, { type IconProps } from './SvgIcon'

const PATH =
  'M50 17.94l8.93 19 1.24 2.66 2.91.44 20.51 3.16-15 15.4-1.94 2 .45 2.74 3.49 21.39-17.9-9.9L50 73.34l-2.66 1.47-17.9 9.9 3.49-21.39.45-2.74-1.94-2-15-15.4 20.51-3.14 2.91-.44 1.21-2.6L50 18m0-13L36.09 34.63 5 39.38l22.5 23.06L22.19 95 50 79.63 77.81 95 72.5 62.44 95 39.38l-31.09-4.75L50 5z'

const IconStarEmpty: FC<IconProps> = props => <SvgIcon {...props} path={PATH} />

export default IconStarEmpty
